<div class="create-education create-education-two">
    <div class="create-education-wrap">
        <div class="create-education-left">
            <h2>Educación</h2>
        </div>

        <div class="create-education-right">
            <a (click)="mostrarEdicionEducacion()">+ Añadir Educación</a>
        </div>
    </div>

    <div>
        <div class="container" *ngIf="!mostrarEdicion">
            <div class="row" *ngFor="let escolaridad of escolaridades | paginate: { itemsPerPage: 1, currentPage: noPagina }">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Título</label>
                        <input type="text" class="form-control" [value]="escolaridad.titulo" readonly>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Instituto</label>
                        <input type="text" class="form-control" [value]="escolaridad.institucion" readonly>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Año Inicio</label>
                        <input type="text" class="form-control" [value]="escolaridad.anioInicio" readonly>
                    </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                      <label>Año Fin</label>
                      <input type="text" class="form-control" [value]="escolaridad.anioFin" readonly>
                  </div>
                </div>

                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="text-left">
                            <button type="button" class="btn btn-default-ac" (click)="habilitarEdicion(escolaridad)">Editar Actual</button>
                            <button type="button" class="btn btn-default-ac" (click)="eliminarEscolaridadPorId(escolaridad.idEscolaridad)">Eliminar Actual</button>
                        </div>
                    </div>
                </div>

                <div class="aling-center">
                    <pagination-controls class="page-numbers" (pageChange)="noPagina = $event"
                        [responsive]="true" [previousLabel]="''" [nextLabel]="''"></pagination-controls>
                </div>
            </div>
        </div>
        <div class="container" *ngIf="mostrarEdicion">
            <form [formGroup]="formEdu" (ngSubmit)="validarEscolaridad()">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Título*</label>
                            <input type="text" class="form-control" [placeholder]="grado.titulo || 'Ingeniería en Sistemas...'" formControlName="grado">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formEdu.controls.grado.errors &&
                                (formEdu.controls.grado.dirty || formEdu.controls.grado.touched)">
                                <div *ngIf="formEdu.controls.grado.errors.required">El título es requerida</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Institución*</label>
                            <input type="text" class="form-control" [placeholder]="grado.institucion|| 'Universidad...'" formControlName="escuela">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formEdu.controls.escuela.errors &&
                                (formEdu.controls.escuela.dirty || formEdu.controls.escuela.touched)">
                                <div *ngIf="formEdu.controls.escuela.errors.required">La institución es requerida</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Año Inicio</label>
                            <input type="text" class="form-control" [placeholder]="grado.anioInicio || 'Año inicio'" formControlName="inicio">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formEdu.controls.inicio.errors &&
                                (formEdu.controls.inicio.dirty || formEdu.controls.inicio.touched)">
                                <div *ngIf="formEdu.controls.inicio.errors.pattern">Solo se permiten números.</div>
                                <div *ngIf="formEdu.controls.inicio.errors.maxlength">El año inicio solo debe contener como máximo 4 dígitos.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group">
                          <label>Año Fin</label>
                          <input type="text" class="form-control" [placeholder]="grado.anioFin || 'Año fin'" formControlName="fin">
                          <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formEdu.controls.fin.errors &&
                                (formEdu.controls.fin.dirty || formEdu.controls.fin.touched)">
                                <div *ngIf="formEdu.controls.fin.errors.pattern">Solo se permiten números.</div>
                                <div *ngIf="formEdu.controls.fin.errors.maxlength">El año fin solo debe contener como máximo 4 dígitos.</div>
                            </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <div class="text-left">
                                <button type="submit" class="btn create-ac-btn">{{(editarEscolariodad ? 'Actualizar' : 'Agregar')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
